import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/actionPlan/pages/ActionPlan'
import { GoalDetailPage } from '@/modules/actionPlan/pages/GoalDetail'
import { ActionPlanRoutePathsEnum } from '@/modules/actionPlan/routes/actionPlanRouteConfig.types'

export const ACTION_PLAN_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: ActionPlanRoutePathsEnum.ACTION_PLAN,
  },
  {
    element: <GoalDetailPage />,
    path: ActionPlanRoutePathsEnum.GOAL_DETAIL,
  },
]
